import React from 'react';
import { graphql, useFragment } from 'react-relay';
import Lozenge from '@atlaskit/lozenge';
import {
	DONE,
	IN_PROGRESS,
	statusCategoryForId,
	TODO,
	UNDEFINED,
} from '@atlassian/jira-common-constants/src/status-categories.tsx';
import type { statusGroupHeader_issueTableGrouping$key } from '@atlassian/jira-relay/src/__generated__/statusGroupHeader_issueTableGrouping.graphql';

export type Props = {
	statusGroupHeader: statusGroupHeader_issueTableGrouping$key | null;
};

const appearanceMap = {
	[UNDEFINED]: 'default',
	[TODO]: 'default',
	[DONE]: 'success',
	[IN_PROGRESS]: 'inprogress',
} as const;

export const StatusGroupHeader = ({ statusGroupHeader }: Props) => {
	const data = useFragment<statusGroupHeader_issueTableGrouping$key>(
		graphql`
			fragment statusGroupHeader_issueTableGrouping on JiraJqlStatusFieldValue {
				displayName
				statusCategory {
					statusCategoryId
				}
			}
		`,
		statusGroupHeader,
	);

	const appearance =
		data?.statusCategory.statusCategoryId != null
			? appearanceMap[statusCategoryForId(data?.statusCategory.statusCategoryId)]
			: appearanceMap[UNDEFINED];

	return <Lozenge appearance={appearance}>{data?.displayName}</Lozenge>;
};
